import WorksheetEditor from "modules/worksheet/WorksheetEditor";
import Decimal from "decimal.js";
import { Worksheet, calculateWorksheet } from "modules/worksheet/calculator";
import { Grid, Skeleton } from "@mui/material";
import MDAlert from "components/MDAlert";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import useGetJobPhase from "hooks/jobs/job-phases/useGetJobPhase";
import View from "modules/JobPhases/View";
import DashboardNavbar from "partials/DashboardNavbar/DashboardNavbar";
import Footer from "partials/Footer/Footer";
import { useParams, useNavigate } from "react-router";
import { getRoute } from "utils/routing";

export default function JobCostPage() {
  const { jobId, jobPhaseId } = useParams();
  const { loading, error, data: jobPhase } = useGetJobPhase({ id: jobPhaseId });

  const navigate = useNavigate();
  const addPhaseCostCompleted = () =>
    navigate(getRoute("jobs.view", [["jobId", jobPhase?.job?.id]]));
  return (
    <DashboardLayout>
      <DashboardNavbar />
      {loading && <>Loading</>}
      {error && (
        <MDAlert color="error">
          Could not load job phase material detail. Please refresh this page or try again later.
        </MDAlert>
      )}
      <MDBox my={3}>
        <MDBox mb={6}>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} lg={6}>
              <MDTypography variant="h4" fontWeight="medium">
                Job #{jobPhase?.job?.externalId || ""} {">"} {jobPhase?.organizationProductTypeName}
              </MDTypography>
            </Grid>
          </Grid>
        </MDBox>
        {jobPhase?.worksheet && (
          <>
            <MDTypography variant="h6">Accepted worksheet estimate</MDTypography>
            <MDTypography variant="body2">
              Estimated margin is based on entered costs. These are estimated costs, not actual job
              expenses.
            </MDTypography>
            <WorksheetEditor
              key={jobPhase.id}
              initial={jobPhase.worksheet as Worksheet}
              discountCents={Decimal.max(
                0,
                calculateWorksheet(jobPhase.worksheet as Worksheet).price.minus(
                  jobPhase.proposedOverallTotal
                )
              ).toFixed(0)}
              readOnly
              onSave={async () => {}}
            />
          </>
        )}
        <Grid container spacing={3}>
          <Grid item xs={12}>
            {!loading && jobPhase && (
              <View
                key={jobPhase.id}
                jobPhase={jobPhase}
                addPhaseCostCompleted={addPhaseCostCompleted}
              />
            )}
            {loading && <Skeleton />}
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
